import React from "react";
import Image from "next/image";
import { m } from "framer-motion";
import { fadeIn } from "@/utils/motion/fade-in";
import Link from "next/link";
export default function BlogLandingBanner({ featured }) {
  return (
    <m.div
      initial={"from"}
      whileInView={"to"}
      variants={fadeIn(0.75)}
      viewport={{ once: true }}
      className={`flex items-center justify-center relative w-full lg:h-screen md:h-[70vh] h-screen overflow-hidden`}
    >
      {/* Background Image */}
      <div className="relative w-full h-full flex flex-col items-center justify-center">
        <Image
          src={
            featured[0]?.coverImage?.data?.attributes?.url ??
            "/images/placeholder.svg"
          }
          alt={
            featured[0]?.coverImage?.data?.attributes?.name ??
            featured[0]?.title ??
            "post image"
          }
          sizes="(max-width: 479px) 479px,(max-width: 767px) 767px,(max-width: 991px) 991px, 1440px"
          fill
          className="w-full h-full object-cover filter blur-sm scale-110"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black/10" />
      </div>

      {/* Content Container */}
      <Link
        href={`/blog-${featured[0]?.slug}`}
        className="absolute z-10 bg-white p-4 shadow-lg w-fit"
      >
        <div className="relative lg:w-[35vw] md:w-[50vw] lg:h-[30vw] md:h-[40vw] w-full h-[300px]">
          <Image
            src={
              featured[0]?.coverImage?.data?.attributes?.url ??
              "/images/placeholder.svg"
            }
            alt={
              featured[0]?.coverImage?.data?.attributes?.name ??
              featured[0]?.title ??
              "post image"
            }
            fill
            sizes="(max-width: 479px) 500px, 500px"
            className="object-cover w-full h-auto"
          />
        </div>

        <div className="flex flex-col mt-5 lg:max-w-[35vw] md:max-w-[50vw] max-w-[300px] w-full gap-1">
          <span className="text-[12px] uppercase text-[#333333]/80">
            Featured
          </span>
          <p className="md:text-lg text-base text-darkGrey/90 !leading-tight">
            {featured[0]?.title}
          </p>
          <h5 className="text-sm text-darkGrey/60 mt-1">
            {featured[0]?.blog_categories?.data[0]?.attributes?.name} | By Admin
          </h5>
        </div>
      </Link>
    </m.div>
  );
}
